import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-gold/20 last:border-0" data-id="element-2">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" onClick={onClick} data-id="element-3">
        <span className="font-serif text-lg md:text-xl text-navy group-hover:text-gold transition-colors pr-4" data-id="element-4">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="flex-shrink-0 text-gold" data-id="element-5">
          <ChevronDown size={24} data-id="element-6" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-7">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-8">
            <div className="pb-6 text-navy/80 leading-relaxed" data-id="element-9">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto bg-white/50 backdrop-blur-sm p-6 md:p-8 rounded-sm shadow-sm border border-gold/10" data-id="element-10">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-11" />)}
    </div>;
}